export default {
  notConnected: 'The asset is not connected to any supported data source.',
};
